import React, { Fragment, useCallback } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const DateRangeFilter = ({ filters, setFilters, dateRangeOptions, fieldName }) => {
    const handleDateRange = useCallback(
        (range) => {
            //console.log("Updating filter date range: ", range);

            setFilters((oldFilters) => {
                const newFilters = {
                    ...oldFilters,
                    date: {
                        ...oldFilters.date,
                        range: range,
                    },
                };
                //console.log("New dates: ", newDates);

                return newFilters;
            });
        },
        [setFilters]
    );

    const handleCustomDate = useCallback(
        (customDate, boundary) => {
            if (!customDate) return;

            //console.log("Setting custom date: ", customDate, boundary);

            try {
                const tzOffset = new Date().getTimezoneOffset();

                const dateFrom = new Date(
                    Date.parse(customDate + "T00:00:00.000Z")
                );
                dateFrom.setMinutes(dateFrom.getMinutes() + tzOffset);

                const dateUntil = new Date(customDate + "T23:59:59.999Z");
                dateUntil.setMinutes(dateUntil.getMinutes() + tzOffset);

                const dateFromString = dateFrom.toISOString();
                const dateUntilString = dateUntil.toISOString();

                setFilters((oldFilters) => {
                    const newFilters = {
                        ...oldFilters,
                        date: {
                            ...oldFilters.date,
                            from:
                                !boundary || boundary === "from"
                                    ? dateFromString
                                    : oldFilters.date.from,
                            until:
                                !boundary || boundary === "until"
                                    ? dateUntilString
                                    : oldFilters.date.until,
                        },
                    };
                    //console.log("New filters: ", newFilters);

                    return newFilters;
                });
            } catch (e) {}
        },
        [setFilters]
    );

    return (
        <Form.Group className="form-group">
            <Form.Label>{ fieldName || "Fecha creación"}</Form.Label>

            <Form.Select
                id="filterDate"
                className=""
                value={filters.date.range}
                onChange={(event) => handleDateRange(event.currentTarget.value)}
            >
                {dateRangeOptions.map((option) => (
                    <option key={"option_" + option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </Form.Select>

            {filters.date && filters.date.range ? (
                <Fragment>
                    {
                        {
                            custom: (
                                <Form.Control
                                    className="mt-4"
                                    id="customDate"
                                    type="date"
                                    required
                                    onChange={(event) =>
                                        handleCustomDate(event.target.value)
                                    }
                                />
                            ),
                            range: (
                                <span>
                                    <InputGroup className="mt-1">
                                        <InputGroup.Text
                                            style={{ width: "2.5rem" }}
                                        >
                                            De
                                        </InputGroup.Text>
                                        <Form.Control
                                            className="mt-0"
                                            id="customDateFrom"
                                            type="date"
                                            required
                                            onChange={(event) =>
                                                handleCustomDate(
                                                    event.target.value,
                                                    "from"
                                                )
                                            }
                                        />
                                    </InputGroup>
                                    <InputGroup>
                                        <InputGroup.Text
                                            style={{ width: "2.5rem" }}
                                        >
                                            A
                                        </InputGroup.Text>
                                        <Form.Control
                                            className="mt-0"
                                            id="customDateTo"
                                            type="date"
                                            required
                                            onChange={(event) =>
                                                handleCustomDate(
                                                    event.target.value,
                                                    "until"
                                                )
                                            }
                                        />
                                    </InputGroup>
                                </span>
                            ),
                        }[filters.date.range]
                    }
                </Fragment>
            ) : null}
        </Form.Group>
    );
};

export default DateRangeFilter;
